export default function Logo({ dark = false, compact = false }) {
  const chip = compact ? 'h-10 w-10 rounded-lg p-1' : 'h-12 w-12 rounded-xl p-1.5';
  const mark = dark ? (
    <span className={`inline-flex items-center justify-center bg-brand-cream ${chip}`}>
      <img
        src="/logo-mark.png"
        alt="Thula Doula Wellness logo"
        className="h-full w-full object-contain mix-blend-multiply"
      />
    </span>
  ) : (
    <img
      src="/logo-mark.png"
      alt="Thula Doula Wellness logo"
      className={compact ? 'h-9 w-9 object-contain mix-blend-multiply' : 'h-11 w-11 object-contain mix-blend-multiply'}
    />
  );

  return (
    <span className="inline-flex items-center gap-3" data-testid="brand-logo">
      {mark}
      <span className="flex flex-col leading-none">
        <span
          className={`text-[15px] font-extrabold uppercase tracking-[0.12em] ${
            dark ? 'text-brand-cream' : 'text-brand-ink'
          }`}
        >
          Thula Doula Wellness
        </span>
      </span>
    </span>
  );
}
